import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  Box,
  Flex,
  Input,
  InputGroup,
  InputRightElement,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Thead,
  Tr,
  HStack,
  Img,
  Button,
  Image,
  MenuItem,
  MenuList,
  MenuButton,
  Menu,
  useDisclosure,
  Skeleton,
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";
import { formatTableValue } from "./formatTable";
import chevronLeft from "../../assets/images/employee/chevron-left.svg";
import chevronRight from "../../assets/images/employee/chevron-right.svg";
import useDebounce from "../../hooks/useDebounce";
import ReactPaginate from "react-paginate";
import iconDetail from "../../assets/images/contract/Frame (1).svg";
import { AiOutlineMore } from "react-icons/ai";
import { useServiceFee } from "../../hooks/useServiceFee";
import DatePicker from "react-datepicker";
import calendarIcon from "../../assets/images/onleave/calendar.svg";
import { vi } from "date-fns/locale";
import FormDetail from "./form/detail";

const TableSeriveFee = ({ isRefetchingWithCreate, paramData }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [search, setSearch] = useState("");
  const [dataEdit, setDataEdit] = useState(null);
  const [date, setDate] = useState(null);

  const debouncedSearchTerm = useDebounce(search, 500);
  const onChangeSearch = useCallback((e) => {
    const { value } = e.target;
    setSearch(value);
  });

  const {
    serviceFeeData,
    totalServiceFee,
    refetch,
    isLoading,
    isRefetching,
    totalPages,
    setCurrentPage,
    currentPage,
    entries,
    startEntry,
    endEntry,
  } = useServiceFee(
    debouncedSearchTerm,
    date && date.getMonth() + 1,
    date && date.getFullYear()
  );

  // refech create
  function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    }, [value]);
    return ref.current;
  }
  const prevIsRefetchingWithCreate = usePrevious(isRefetchingWithCreate);

  useEffect(() => {
    if (
      isRefetchingWithCreate &&
      prevIsRefetchingWithCreate !== isRefetchingWithCreate
    ) {
      refetch();
    }
  }, [isRefetchingWithCreate, prevIsRefetchingWithCreate, refetch]);

  useEffect(() => {
    paramData({
      search: debouncedSearchTerm,
      month: date && date.getMonth() + 1,
      year: date && date.getFullYear(),
    });
  }, [debouncedSearchTerm, date]);

  const handlePageChange = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1);
    refetch();
  };

  const tableData = {
    headers: [
      {
        label: "",
        key: "",
      },
      {
        label: "Thời gian",
        key: "time",
      },
      {
        label: "Mã NV",
        key: "code",
      },
      {
        label: "Tên nhân viên",
        key: "fullName",
      },
      {
        label: "Chức vụ",
        key: "jobTitle",
      },
      {
        label: "Số điện thoại",
        key: "phone",
      },
      {
        label: "Khối",
        key: "saleBlock",
      },
      {
        label: "Vùng",
        key: "saleArea",
      },
      {
        label: "Tổng PDV",
        key: "serviceFee",
      },
    ],
    data: serviceFeeData,
  };

  // table
  const handlePopup = (type, e) => {
    if (type) {
      setDataEdit(e?.edit);
    } else {
      setDataEdit(e?.detail);
    }

    onOpen();
  };

  return (
    <>
      <Flex flexDirection={"column"} gap={{ base: "16px" }}>
        <Flex
          backgroundColor="var(--color-main)"
          borderRadius={{ base: "12px" }}
          flexDirection={"column"}
        >
          <Text
            p={"16px 16px 0px 16px"}
            fontWeight={600}
            color={"var(--color-info-employee)"}
          >
            Hoa hồng của nhân viên
          </Text>
          <Flex
            alignItems={"center"}
            justifyContent={"space-between"}
            gap={{ base: "32px" }}
            p={"16px 16px 12px 16px"}
          >
            <Flex
              alignItems={"flex-start"}
              gap={{ base: "16px 32px" }}
              flex={"1"}
              flexDirection={"column"}
            >
              <InputGroup
                maxW="42vw"
                minW={"42vw"}
                borderRadius={{ base: "8px" }}
                w={{ base: "100%" }}
              >
                <Input
                  placeholder="Nhận Mã NV,tên nhân viên..."
                  type="text"
                  borderRadius={{ base: "8px" }}
                  border={{ base: "1px solid var(--color-boder)" }}
                  backgroundColor={"var(--fill-avatar)"}
                  onChange={onChangeSearch}
                />
                <InputRightElement
                  borderTopRightRadius={"8px"}
                  borderBottomRightRadius={"8px"}
                  pointerEvents="none"
                  cursor={"pointer"}
                  backgroundImage="var(--color-button)"
                >
                  <SearchIcon color="var(--color-main)" />
                </InputRightElement>
              </InputGroup>
              <Flex
                alignItems={"center"}
                gap={{ base: "16px 32px" }}
                flex={"1"}
                flexWrap={"wrap"}
                w={"100%"}
              >
                <InputGroup w={"100%"} maxW={"255px"}>
                  <DatePicker
                    selected={date}
                    onChange={(date) => setDate(date)}
                    dateFormat="MM/yyyy"
                    showMonthYearPicker
                    isClearable={true}
                    placeholderText="Tháng năm (MM/yyyy)"
                    className="datePickerStyle"
                    locale={vi}
                  />
                  {!date && (
                    <InputRightElement pointerEvents="none" h={"44px"}>
                      <Image src={calendarIcon} />
                    </InputRightElement>
                  )}
                </InputGroup>
              </Flex>
            </Flex>
          </Flex>
          <Box width={"100%"} height={"100%"}>
            <Skeleton isLoaded={!isLoading && !isRefetching}>
              <TableContainer
                w={"100%"}
                maxH="calc(100vh - 350.5px)"
                overflowY="auto"
              >
                <Table w={"100%"} variant="unstyled">
                  <Thead
                    position="sticky"
                    top="0"
                    zIndex="1"
                    w={"100%"}
                    h={"41px"}
                    color="white"
                    fontWeight="400"
                    backgroundColor="#F9FAFD"
                  >
                    <Tr h={{ base: "41px" }}>
                      {tableData.headers.map((e, index) => {
                        let width = "auto";
                        let textAlign = "auto";
                        if (e.key === "") {
                          width = "2%";
                          textAlign = "center";
                        } else if (e.key === "code") {
                          width = "5%";
                          textAlign = "start";
                        } else if (e.key === "fullName") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "jobTitle") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "phone") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "saleBlock") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "saleArea") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "saleBlock") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "time") {
                          width = "10%";
                          textAlign = "start";
                        } else {
                          width = "10%";
                          textAlign = "end";
                        }
                        return (
                          <Td
                            p={"16px 16px 8px 16px"}
                            key={index}
                            border={"none"}
                            color={"#51607B"}
                            fontSize={{ base: "14px" }}
                            w={width}
                          >
                            <Box textAlign={"center"} fontWeight={"bold"}>{e.label}</Box>
                          </Td>
                        );
                      })}
                    </Tr>
                  </Thead>
                  <Tbody
                    w={"100%"}
                    h={"100%"}
                    borderBottom={"1px solid var(--color-black-2)"}
                    borderTop={"1px solid var(--color-black-2)"}
                  >
                    {tableData.data?.length > 0 ? (
                      tableData.data?.map((e, rowIndex) => {
                        const items = { ...e };
                        delete items.id;
                        delete items.edit;
                        delete items.detail;
                        const keyValues = Object.keys(items);
                        return (
                          <Tr key={rowIndex} h={"72px"}>
                            <Td p={"16px 16px 8px 16px"} w={"2%"}>
                              <Menu>
                                <MenuButton
                                  _hover={{ backgroundColor: "none" }}
                                  _active={{ backgroundColor: "none" }}
                                  background="none"
                                  as={Button}
                                >
                                  <AiOutlineMore fontSize={"20px"} />
                                </MenuButton>
                                <MenuList
                                  fontSize={{ base: "14px" }}
                                  fontWeight={500}
                                  lineHeight={"140%"}
                                  color={"var(--color-info-employee)"}
                                >
                                  <MenuItem
                                    gap={"16px"}
                                    onClick={() => handlePopup(false, e)}
                                  >
                                    <Image src={iconDetail} /> Xem chi tiết
                                  </MenuItem>
                                </MenuList>
                              </Menu>
                            </Td>
                            {keyValues.map((keyvalue, index) => {
                              let width = "auto";
                              let widthText = "100%";
                              let textAlign = "auto";
                              let whiteSpace = "inherit";
                              if (keyvalue === "") {
                                width = "2%";
                                textAlign = "center";
                              } else if (keyvalue === "code") {
                                width = "5%";
                                textAlign = "start";
                              } else if (keyvalue === "fullName") {
                                width = "10%";
                                textAlign = "start";
                              } else if (keyvalue === "jobTitle") {
                                width = "10%";
                                textAlign = "start";
                              } else if (keyvalue === "phone") {
                                width = "10%";
                                textAlign = "start";
                              } else if (keyvalue === "saleBlock") {
                                width = "10%";
                                textAlign = "start";
                              } else if (keyvalue === "saleArea") {
                                width = "10%";
                                textAlign = "start";
                              } else if (keyvalue === "time") {
                                width = "10%";
                                textAlign = "start";
                              } else {
                                width = "10%";
                                textAlign = "end";
                                whiteSpace = "inherit";
                              }
                              return (
                                <Td
                                  p={"16px 16px 8px 16px"}
                                  w={width}
                                  key={index}
                                >
                                  <Box
                                    fontSize={{ base: "14px" }}
                                    lineHeight={"19.6px"}
                                    textAlign={"start"}
                                    fontWeight={500}
                                    color={"var(--color-info-employee)"}
                                    w={widthText}
                                    whiteSpace={whiteSpace}
                                    overflow="hidden"
                                    textOverflow="ellipsis"
                                    display="-webkit-box"
                                    sx={{
                                      WebkitLineClamp: "2",
                                      WebkitBoxOrient: "vertical",
                                    }}
                                  >
                                    {formatTableValue(e[keyvalue], keyvalue)}
                                  </Box>
                                </Td>
                              );
                            })}
                          </Tr>
                        );
                      })
                    ) : (
                      <Tr>
                        <Td
                          colSpan={tableData.headers.length}
                          textAlign="center"
                          padding={"40px 0"}
                        >
                          Không có dữ liệu
                        </Td>
                      </Tr>
                    )}
                  </Tbody>
                </Table>
              </TableContainer>
            </Skeleton>
            <Box mt={4} mr={5} ml={5}>
              <Flex
                alignItems={"center"}
                justifyContent={"flex-end"}
                gap={"35px"}
              >
                <Text
                  fontSize={"14px"}
                  color={"var(--color-label-employee)"}
                  fontWeight={400}
                >
                  Tổng PDV:
                </Text>
                <Text
                  fontSize={"14px"}
                  color={"var(--color-option-employee-hover)"}
                  fontWeight={400}
                >
                  {totalServiceFee}
                </Text>
              </Flex>
            </Box>
            <Box mt={10} mr={5} mb={5} ml={5}>
              <Flex alignItems={"center"} justifyContent={"space-between"}>
                <Text>
                  Showing {startEntry} to {endEntry} of {entries} entries
                </Text>
                <HStack spacing={2} justify="flex-end">
                  <ReactPaginate
                    className="pagination-custom"
                    pageCount={totalPages}
                    pageRangeDisplayed={3}
                    marginPagesDisplayed={1}
                    onPageChange={handlePageChange}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                    breakClassName={"ellipsis"}
                    breakLabel={"..."}
                    previousLabel={
                      <Img
                        w={"16px"}
                        minW={"16px"}
                        h={"16px"}
                        src={chevronLeft}
                      />
                    }
                    nextLabel={
                      <Img
                        w={"16px"}
                        minW={"16px"}
                        h={"16px"}
                        src={chevronRight}
                      />
                    }
                    renderOnZeroPageCount={null}
                    forcePage={currentPage - 1}
                  />
                </HStack>
              </Flex>
            </Box>
          </Box>
        </Flex>
      </Flex>
      <FormDetail
        isOpen={isOpen}
        onClose={onClose}
        isEdit={true}
        defaultValues={dataEdit}
        isLoading={isLoading}
        isRefetching={isRefetching}
        // onSubmit={onSubmitEdit}
      />
    </>
  );
};

export default TableSeriveFee;
